
<div class="page-header">
  <div>
    <h1>Organisationen</h1>
    <p>Superadmin-&Uuml;bersicht &uuml;ber Zentralen, Partner und angeschlossene Organisation.</p>
    <p>&Auml;nderungen an der Organisation werden f&auml;r alle zugeordneten Unternehmen sichtbar.</p>
  </div>
  <button type="button" class="primary-button" (click)="openCreateDialog()">Organisation anlegen</button>
</div>

<section class="panel section-stack">
  <div class="filter-bar">
    <label>
      <span>Suche</span>
      <input type="search" placeholder="Organisation, Ansprechpartner oder Betreuer" [value]="search()" (input)="setSearch($event)" (keydown.enter)="load()">
    </label>

    <label>
      <span>Status</span>
      <select [value]="status()" (change)="setStatus($event)">
        <option value="">Alle</option>
        <option value="ACTIVE">Aktiv</option>
        <option value="TEST">Test</option>
        <option value="INACTIVE">Inaktiv</option>
      </select>
    </label>

    <button type="button" class="primary-button" (click)="load()">Filtern</button>
    <button type="button" class="ghost-button" (click)="reset()">Zurücksetzen</button>
  </div>

  @if (organizations(); as page) {
    <table class="table organization-table">
      <thead>
        <tr>
          <th>Organisation</th>
          <th>Typ</th>
          <th>Ansprechpartner</th>
          <th>E-Mail</th>
          <th>Betreuer</th>
          <th>Status</th>
          <th>Status bis</th>
          <th>Unternehmer</th>
          <th>Fahrer</th>
          <th>Benutzer</th>
          <th>Aktion</th>
        </tr>
      </thead>
      <tbody>
        @for (organization of page.items; track organization.id) {
          <tr>
            <td data-label="Organisation">
              <strong>{{ organization.name }}</strong><br>
              <span>{{ address(organization) }}</span>
            </td>
            <td data-label="Typ">{{ typeLabel(organization.organizationType) }}</td>
            <td data-label="Ansprechpartner">{{ valueOrDash(organization.contactName) }}</td>
            <td data-label="E-Mail">{{ valueOrDash(organization.contactEmail) }}</td>
            <td data-label="Betreuer">{{ valueOrDash(organization.advisor) }}</td>
            <td data-label="Status"><span class="badge">{{ statusLabel(organization.status) }}</span></td>
            <td data-label="Status bis">{{ valueOrDash(organization.statusValidUntil) }}</td>
            <td data-label="Unternehmer">{{ organization.companyCount }}</td>
            <td data-label="Fahrer">{{ organization.driverCount }}</td>
            <td data-label="Benutzer">{{ organization.activeUserCount }}</td>
            <td data-label="Aktion">
              <div class="mini-button-stack">
                <button type="button" class="ghost-button" (click)="openEditDialog(organization)">Bearbeiten</button>
                <button type="button" class="ghost-button danger-button" (click)="deleteOrganization(organization)">Löschen</button>
              </div>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="11">Keine Organisationen gefunden.</td>
          </tr>
        }
      </tbody>
    </table>
    @if (deleteError()) {
      <p class="field-error">{{ deleteError() }}</p>
    }
  } @else {
    <div class="empty">Organisationen werden geladen.</div>
  }
</section>

@if (dialogOpen()) {
  <div class="modal-backdrop" role="presentation" (click)="closeDialog()">
    <section class="modal-panel" role="dialog" aria-modal="true" aria-labelledby="organization-dialog-title" (click)="$event.stopPropagation()">
      <div class="panel-heading">
        <div>
          <h2 id="organization-dialog-title">{{ editingId() ? 'Organisation bearbeiten' : 'Organisation anlegen' }}</h2>
          <p>Stammdaten, Status und internen Betreuer erfassen.</p>
        </div>
        <button type="button" class="ghost-button" (click)="closeDialog()">Schließen</button>
      </div>

      <form class="dialog-form" (submit)="save($event)">
        <label class="full-width">
          <span>Name</span>
          <input type="text" required [value]="form().name" (input)="updateForm('name', $event)">
        </label>

        <label>
          <span>Typ</span>
          <select [value]="form().organizationType" (change)="updateForm('organizationType', $event)">
            <option value="CENTRAL">Zentrale</option>
            <option value="ASSOCIATION">Verband</option>
            <option value="PARTNER">Partner</option>
            <option value="SINGLE_COMPANY">Einzelunternehmen</option>
          </select>
        </label>

        <label>
          <span>Status</span>
          <select [value]="form().status" (change)="updateForm('status', $event)">
            <option value="ACTIVE">Aktiv</option>
            <option value="TEST">Test</option>
            <option value="INACTIVE">Inaktiv</option>
          </select>
        </label>

        <label>
          <span>Status gültig bis</span>
          <input type="date" [value]="form().statusValidUntil" (input)="updateForm('statusValidUntil', $event)">
        </label>

        <label>
          <span>Interner Betreuer</span>
          <input type="text" [value]="form().advisor" (input)="updateForm('advisor', $event)">
        </label>

        <label>
          <span>Ansprechpartner</span>
          <input type="text" [value]="form().contactName" (input)="updateForm('contactName', $event)">
        </label>

        <label>
          <span>E-Mail</span>
          <input type="email" [value]="form().contactEmail" (input)="updateForm('contactEmail', $event)">
        </label>

        <label>
          <span>Telefon</span>
          <input type="tel" [value]="form().contactPhone" (input)="updateForm('contactPhone', $event)">
        </label>

        <label>
          <span>Straße</span>
          <input type="text" [value]="form().street" (input)="updateForm('street', $event)">
        </label>

        <label>
          <span>PLZ</span>
          <input type="text" [value]="form().postalCode" (input)="updateForm('postalCode', $event)">
        </label>

        <label>
          <span>Ort</span>
          <input type="text" [value]="form().city" (input)="updateForm('city', $event)">
        </label>

        <label>
          <span>Land</span>
          <input type="text" [value]="form().country" (input)="updateForm('country', $event)">
        </label>

        @if (error()) {
          <p class="field-error full-width">{{ error() }}</p>
        }

        <div class="dialog-actions full-width">
          <button type="submit" class="primary-button" [disabled]="saving()">
            {{ saving() ? 'Wird gespeichert...' : 'Speichern' }}
          </button>
          <button type="button" class="ghost-button" (click)="closeDialog()">Abbrechen</button>
        </div>
      </form>
    </section>
  </div>
}
  
